import React, { useEffect, useState } from "react";
import Button from "./form/Button";
import { ICONS } from "../utils/assets";

export const PopUp = ({ open, title, text, onClose, buttonText }) => {
  const [showPopUp, setShowPopUp] = useState(false);

  useEffect(() => {
    if (open) {
      setShowPopUp(true);
    }
  }, [open]);

  const closePopup = () => {
    setShowPopUp(false);
    onClose();
  };

  return (
    <>
      {showPopUp && (
        <div className="overlay">
          <div className={`popup popup--active`}>
            <div className="popup__content">
              {title && (
                <span className="paragraph-md semibold text-neutral-950">
                  {title}
                </span>
              )}
              <p className="paragraph-md">{text}</p>
            </div>

            <Button
              variant="outlined"
              width="100%"
              onClick={() => closePopup()}
            >
              {buttonText || "Confirm"}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
